// ключі аналітики
export const TIKTOK_PIXEL_ID = 'D200773C77UCQ41MLF1G';
export const ESPUTNIK_ACCOUNT_ID = 'B93D0E7CA0084D7F810E917E4295EBC5';
